import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaPlan } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const planAccess = permission.find((o) => o.slug === "plans");
const couponAccess = permission.find((o) => o.slug === "coupons");
const taxRateAccess = permission.find((o) => o.slug === "tax_rates");


const PlansSubMenu = () => {

    const hasReadPermissionForPlans = planAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForCoupons = couponAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForTaxes = taxRateAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    if (
        !hasReadPermissionForPlans &&
        !hasReadPermissionForCoupons &&
        !hasReadPermissionForTaxes
    ) {
        return null
    }

    return (
        <>
            <Tooltip title='Plans and billing' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaPlan />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>

                    {hasReadPermissionForPlans &&
                        <>
                            <TextLink
                                to="/plans"
                                onClick={handleClose}
                            >
                                Subscription Plans
                            </TextLink>
                            <TextLink
                                to="/credits"
                                onClick={handleClose}
                            >
                                Credits Plans
                            </TextLink>
                            <TextLink
                                to="/sponsership-plans"
                                onClick={handleClose}
                            >
                                Sponsership Plans
                            </TextLink>
                        </>
                    }
                    {hasReadPermissionForTaxes &&
                        <TextLink
                            to="/tax-rates"
                            onClick={handleClose}
                        >
                            Tax Rates
                        </TextLink>
                    }
                    {hasReadPermissionForCoupons &&
                        <TextLink
                            to="/coupons"
                            onClick={handleClose}
                        >
                            Coupons
                        </TextLink>
                    }

                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default PlansSubMenu